import { InlineDeltaToMarkdownAdapterExtension } from '@blocksuite/affine-shared/adapters';

export const boldDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'bold',
    match: delta => !!delta.attributes?.bold,
    toAST: (_, context) => {
      const { current: currentMdast } = context;
      return {
        type: 'strong',
        children: [currentMdast],
      };
    },
  });

export const italicDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'italic',
    match: delta => !!delta.attributes?.italic,
    toAST: (_, context) => {
      const { current: currentMdast } = context;
      return {
        type: 'emphasis',
        children: [currentMdast],
      };
    },
  });

export const strikeDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'strike',
    match: delta => !!delta.attributes?.strike,
    toAST: (_, context) => {
      const { current: currentMdast } = context;
      return {
        type: 'delete',
        children: [currentMdast],
      };
    },
  });

export const inlineCodeDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'inlineCode',
    match: delta => !!delta.attributes?.code,
    toAST: delta => ({
      type: 'inlineCode',
      value: delta.insert,
    }),
  });

export const imageDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'image',
    match: delta => !!delta.attributes?.image?.src,
    toAST: delta => ({
      type: 'image',
      url: delta.attributes?.image?.src ?? '',
      alt: delta.attributes?.image?.alt ?? '',
      title: delta.attributes?.image?.title ?? undefined,
    }),
  });

export const videoDeltaToMarkdownAdapterMatcher =
  InlineDeltaToMarkdownAdapterExtension({
    name: 'video',
    match: delta => !!delta.attributes?.video?.src,
    toAST: delta => ({
      type: 'link',
      url: delta.attributes?.video?.src ?? '',
      children: [
        {
          type: 'text',
          value:
            (delta.attributes?.video?.alt || delta.attributes?.video?.src) ??
            '',
        },
      ],
    }),
  });

export const InlineDeltaToMarkdownAdapterExtensions = [
  inlineCodeDeltaToMarkdownAdapterMatcher,
  boldDeltaToMarkdownAdapterMatcher,
  italicDeltaToMarkdownAdapterMatcher,
  strikeDeltaToMarkdownAdapterMatcher,
  imageDeltaToMarkdownAdapterMatcher,
  videoDeltaToMarkdownAdapterMatcher,
];
